<template>
	<div>
		<v-navigation-drawer
			v-model="updateDrawer"
			right
			app
			stateless
			temporary
			active-class="background-color: 'red'"
			:width="480"
			style="z-index: 2000">
			<profile-settings v-if="page2 === 'settings'"></profile-settings>
			<medical-staff-edit v-if="page2 === 'medicalstaff'"></medical-staff-edit>
			<medical-team-edit v-if="page2 === 'medicalteam'"></medical-team-edit>
			<assessments-edit v-if="page2 === 'wellnessassessments'"></assessments-edit>
			<patient-edit v-if="page2 === 'patientdetails' && activePatientDetailsDrawer == 'patientEdit'" />
			<DiagnosisEdit v-if="page2 === 'patientdetails' && activePatientDetailsDrawer == 'diagnosisEdit'" />
			<AllergiesEdit v-if="page2 === 'patientdetails' && activePatientDetailsDrawer == 'allergiesEdit'" />
			<MedicationAdd v-if="page2 === 'patientdetails' && activePatientDetailsDrawer == 'medicationAdd'" />
			<AddNoteDrawer v-if="page2 === 'patientdetails' && activePatientDetailsDrawer == 'addNote'" />
			<EditNoteDrawer v-if="page2 === 'patientdetails' && activePatientDetailsDrawer == 'editNote'" />
			<!--		<EditNoteDrawer v-if="$route.path.match(/\/patientdetails\/\d+/ && activePatientDetailsDrawer == 'editNote'" ></EditNoteDrawer>-->
			<monitoring-plans-edit v-if="page2 === 'patientdetails' && activePatientDetailsDrawer == 'monitoringPlansEdit'" />
			<!--		<notification-drawer v-if="$route.path === '/dashboard'"></notification-drawer>-->
			<verifier-edit v-if="page2 === 'verifier'"></verifier-edit>
			<medical-institution-edit v-if="page2 === 'medicalinstitution'"></medical-institution-edit>
			<hospital-edit v-if="page2 === 'offices'"></hospital-edit>
			<hospital-admin-edit v-if="page2 === 'admins'"></hospital-admin-edit>
			<edit-monitoring-drawer v-if="page2 === 'monitoring'"></edit-monitoring-drawer>
			<edit-billings-authorization-template v-if="page2 === 'billings authorization'" />
			<medical-note-category-edit v-if="page2 === 'medical notes'" />
			<billings-users-authorization-edit v-if="page2 === 'user billings'" />
			<add-aditional-note v-if="page2 === 'patientdetails' && activePatientDetailsDrawer == 'addAditionalNote'" />
			<edit-invoices v-if="page2 === 'invoices'"></edit-invoices>
			<edit-billing-link v-if="page2 === 'links'"></edit-billing-link>
			<edit-license-drawer v-if="page2 === 'licence'"></edit-license-drawer>
			<CCMInfoEdit v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer == 'CCMInfoEdit'" />
			<CCMFunctionalStatusEdit
				v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmFunctionalStatusEdit'" />
			<CCMConditionEdit v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmConditionEdit'" />
			<CCMConditionHistoryEdit
				v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmConditionHistoryEdit'" />
			<CCMCarePlanEdit v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmCarePlanEdit'" />
			<CCMMedicationEventEdit
				v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmMedicationEventEdit'" />
			<CCMMedicalNoteEdit v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmMedicalNoteEdit'" />
			<CCMVitalEntryEdit v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmVitalEntryEdit'" />
			<CCMObservationEdit v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmObservationEdit'" />
			<CCMAllergyEdit v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmAllergyEdit'" />
			<CCMComplexDecisionMakingEdit
				v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmComplexDecisionMakingEdit'" />
			<CCMSocialDeterminantsEdit
				v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmSocialDeterminantsEdit'" />
			<CCMVaccineEdit v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmVaccineEdit'" />
			<CCMLabsEdit v-if="page2 === 'ccmDetails' && activePatientDetailsDrawer === 'ccmLabsEdit'" />
			<OrganizationMappingEdit v-if="page2 === '/organizationMapping'" />
			<OrganizationMappingEditPcc v-if="page2 === '/organizationMappingPcc'" />
			<LocationMappingEdit v-if="page2 === '/locationMapping'" />
			<LocationMappingEditPcc v-if="page2 === '/pccLocationMapping'" />
			<ScheduleEdit v-if="page2 === 'schedules'" />
			<EditInventoryItemCatalogDrawer v-if="page2 === 'itemCatalogEdit'" />
			<EditInventoryConsumableCatalogDrawer v-if="page2 === 'consumable catalog'" />
			<EditInventoryConsumable v-if="page2 === 'assign consumable catalog'" />
			<EditInventoryItem v-if="page2 === 'inventoryItemEdit'" />
			<DeviceTemplateEdit v-if="page2 === 'device template edit'" />
		</v-navigation-drawer>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import MedicalStaffEdit from '../DrawerDialogs/MedicalStaffEdit.vue';
import MedicalTeamEdit from '../DrawerDialogs/MedicalTeamEdit.vue';
import PatientEdit from '../DrawerDialogs/PatientEdit.vue';
import AssessmentsEdit from '../DrawerDialogs/AssessmentsEdit.vue';
import MonitoringPlansEdit from '../DrawerDialogs/MonitoringPlansEdit.vue';
import DiagnosisEdit from '../DrawerDialogs/DiagnosisEdit.vue';
import AllergiesEdit from '../DrawerDialogs/AllergiesEdit.vue';
import MedicationAdd from '../DrawerDialogs/MedicationAdd.vue';
import AddNoteDrawer from '../DrawerDialogs/AddNoteDrawer.vue';
// import NotificationDrawer from '../DrawerDialogs/NotificationDrawer.vue';
import VerifierEdit from '../DrawerDialogs/VerifierEdit.vue';
import MedicalInstitutionEdit from '../DrawerDialogs/MedicalInstitutionEdit.vue';
import HospitalEdit from '../DrawerDialogs/HospitalEdit.vue';
import HospitalAdminEdit from '../DrawerDialogs/HospitalAdminEdit.vue';
import EditNoteDrawer from '../DrawerDialogs/EditNoteDrawer.vue';
import EditMonitoringDrawer from '../DrawerDialogs/EditMonitoringDrawer';
import ProfileSettings from '../DrawerDialogs/ProfileSettings.vue';
import EditBillingsAuthorizationTemplate from '../DrawerDialogs/EditBillingSettingsTemplate.vue';
import medicalNoteCategoryEdit from '../DrawerDialogs/MedicalNoteCategoryEdit';
import BillingsUsersAuthorizationEdit from '../DrawerDialogs/EditUserBillingSettings.vue';
import AddAditionalNote from '../DrawerDialogs/AddAditionalNote.vue';
import EditInvoices from '../DrawerDialogs/EditInvoices.vue';
import EditBillingLink from '../DrawerDialogs/EditBillingLink.vue';
import EditLicenseDrawer from '../DrawerDialogs/EditLicenseDrawer.vue';
import CCMInfoEdit from '../DrawerDialogs/CCMInfoEdit.vue';
import CCMFunctionalStatusEdit from '../DrawerDialogs/CCMFunctionalStatusEdit.vue';
import CCMConditionEdit from '../DrawerDialogs/CCMConditionEdit.vue';
import CCMCarePlanEdit from '../DrawerDialogs/CCMCarePlanEdit.vue';
import CCMMedicationEventEdit from '../DrawerDialogs/CCMMedicationEventEdit.vue';
import CCMMedicalNoteEdit from '../DrawerDialogs/CCMMedicalNoteEdit.vue';
import CCMVitalEntryEdit from '../DrawerDialogs/CCMVitalEntryEdit.vue';
import CCMObservationEdit from '../DrawerDialogs/CCMObservationEdit.vue';
import CCMAllergyEdit from '../DrawerDialogs/CCMAllergyEdit.vue';
import CCMConditionHistoryEdit from '../DrawerDialogs/CCMConditionHistoryEdit.vue';
import CCMComplexDecisionMakingEdit from '../DrawerDialogs/CCMComplexDecisionMakingEdit.vue';
import CCMSocialDeterminantsEdit from '../DrawerDialogs/CCMSocialDeterminantsEdit.vue';
import CCMVaccineEdit from '../DrawerDialogs/CCMVaccineEdit.vue';
import CCMLabsEdit from '../DrawerDialogs/CCMLabsEdit.vue';
import OrganizationMappingEdit from '../DrawerDialogs/OrganizationMappingEdit.vue';
import OrganizationMappingEditPcc from '../DrawerDialogs/OrganizationMappingEditPcc.vue';
import LocationMappingEdit from '../DrawerDialogs/LocationMappingEdit.vue';
import ScheduleEdit from '../DrawerDialogs/ScheduleEdit.vue';
import LocationMappingEditPcc from '../DrawerDialogs/LocationMappingEditPcc.vue';
import EditInventoryItemCatalogDrawer from '../DrawerDialogs/EditInventoryItemCatalogDrawer.vue';
import EditInventoryConsumableCatalogDrawer from '../DrawerDialogs/EditInventoryConsumableCatalogDrawer.vue';
import EditInventoryConsumable from '../DrawerDialogs/EditInventoryConsumableDrawer.vue';
import EditInventoryItem from '../DrawerDialogs/EditInventoryItemDrawer.vue';
import DeviceTemplateEdit from '../DrawerDialogs/DeviceTemplateEdit.vue';

export default {
	components: {
		EditLicenseDrawer,
		AddAditionalNote,
		medicalNoteCategoryEdit,
		BillingsUsersAuthorizationEdit,
		EditBillingsAuthorizationTemplate,
		ProfileSettings,
		AssessmentsEdit,
		PatientEdit,
		MedicalStaffEdit,
		MedicalTeamEdit,
		MonitoringPlansEdit,
		EditMonitoringDrawer,
		DiagnosisEdit,
		AllergiesEdit,
		MedicationAdd,
		AddNoteDrawer,
		EditInvoices,
		// NotificationDrawer,
		VerifierEdit,
		MedicalInstitutionEdit,
		HospitalEdit,
		HospitalAdminEdit,
		EditNoteDrawer,
		EditBillingLink,
		CCMInfoEdit,
		CCMFunctionalStatusEdit,
		CCMConditionEdit,
		CCMConditionHistoryEdit,
		CCMCarePlanEdit,
		CCMMedicationEventEdit,
		CCMMedicalNoteEdit,
		CCMVitalEntryEdit,
		CCMObservationEdit,
		CCMAllergyEdit,
		CCMComplexDecisionMakingEdit,
		CCMSocialDeterminantsEdit,
		CCMVaccineEdit,
		CCMLabsEdit,
		OrganizationMappingEdit,
		LocationMappingEdit,
		ScheduleEdit,
		OrganizationMappingEditPcc,
		LocationMappingEditPcc,
		EditInventoryItemCatalogDrawer,
		EditInventoryConsumableCatalogDrawer,
		EditInventoryConsumable,
		EditInventoryItem,
		DeviceTemplateEdit,
	},
	data () {
		return {
			activePatientDetailsDrawer: '',
			items: [
				{ title: 'Home', icon: 'mdi-view-dashboard' },
				{ title: 'About', icon: 'mdi-forum' },
			],
		};
	},
	computed: {
		...mapState(['barColor', 'barImage', 'webrtcErrors', 'pageSize']),
		...mapGetters({
			pageWidth: 'pageHeight',
			page2: 'getPage2',
		}),
		updateDrawer: {
			get () {
				this.selectPatientDrawer(this.$store?.state.activePatientsDrawer);
				return this.$store?.state.updateDrawer;
			},
			set (val) {
				this.$store.commit('SET_UPDATE_DETAILS_DRAWER', val);
			},
		},
	},
	methods: {
		selectPatientDrawer (dat) {
			this.activePatientDetailsDrawer = dat;
		},
		clearDrawer () {
			this.$store.commit('SET_PATIENT_DETAILS_DRAWER', '');
			// this.activePatientDetailsDrawer = '';
		},
	},
	watch: {
		getPage2 (val) {},
	},
};
</script>
